import { render } from "./ColorSet.vue?vue&type=template&id=1b78f188&scoped=true"
import script from "./ColorSet.vue?vue&type=script&lang=js"
export * from "./ColorSet.vue?vue&type=script&lang=js"

import "./ColorSet.vue?vue&type=style&index=0&id=1b78f188&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b78f188"]])

export default __exports__